import { render, staticRenderFns } from "./LatestMessageMobile.vue?vue&type=template&id=efda60d2&scoped=true&"
import script from "./LatestMessageMobile.vue?vue&type=script&lang=js&"
export * from "./LatestMessageMobile.vue?vue&type=script&lang=js&"
import style0 from "./LatestMessageMobile.vue?vue&type=style&index=0&id=efda60d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda60d2",
  null
  
)

export default component.exports